import {ReactElement, useEffect, useState} from 'react'
import {Me} from './api/api'
import { NavBar} from './NavBar'
import {LoginHeader} from './LoginHeader'
import {api, useDivisionOrUndefined} from "./shared"
import "./MainPage.scss"
import {LoggedinMainPage} from "./LoggedinMainPage"

export function MainPage(): ReactElement {
  const division = useDivisionOrUndefined()
  const [me, setMe] = useState<Me | undefined>(undefined)
  const [dataRetrievedTime, setDataRetrievedTime] = useState<Date>()
  const [nrErrorsAndWarnings, setNrErrorsAndWarnings] = useState<[number, number]>()

  useEffect(() => {
    api.getMe().then(setMe)
  }, [])

  return  (
    <>
      <div id="header">
        <LoginHeader me={me} dataRetrievedTime={dataRetrievedTime} />
        <NavBar nrErrorsAndWarnings={nrErrorsAndWarnings} />
      </div>
      <div className="mainpage">
      {(division === undefined || api.getApiTokenValidTill() === undefined) ?
        <div>Please log in</div>
        : <LoggedinMainPage setDataRetrievedTime={setDataRetrievedTime}
        setNrErrorsAndWarnings={setNrErrorsAndWarnings} />}
      </div>
    </>
  )
}
